import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';

/**
 * /services/:slug → 301-style redirect to /usa/:slug/
 *
 * Background: the bare-bones DB-driven ServicePage was an admin/seed
 * artifact. The rich marketing pages live at /usa/:slug/ (USAServicePage)
 * with full hero, benefits, FAQ, schema, and CTAs.
 *
 * We keep the /services/* URL pattern functional (existing blog posts,
 * external backlinks, and DB cta_url fields all use it) but route every
 * visitor to the marketing equivalent.
 *
 * Slugs without a /usa/ counterpart fall through to /usa/ (the hub).
 */
const ServiceRedirect = () => {
  const { slug } = useParams();
  const target = slug ? `/usa/${slug}/` : '/usa/';
  useEffect(() => {
    // Help SPAs that hard-cache route resolution
    document.title = 'Redirecting…';
  }, []);
  return <Navigate to={target} replace />;
};

export default ServiceRedirect;
